import Header from "../components/Header";
import Footer from "../components/Footer";

function NoPage() {
  return (
    <div className="flex flex-col flex-grow w-screen min-h-screen items-center">
      <Header />
      <main className="bg-topography w-screen h-screen flex flex-col items-center justify-center">
      <h1 className="text-3xl text-text font-bold">You should not be here!</h1>
      </main>
      <Footer />
    </div>
  );
}

export default NoPage;
